import React, { FC, useContext } from 'react'
import classNames from 'classnames'
import { LOGON_PAGE_TITLE } from '../../constants/logonTitles'
import { REGISTRATION_PAGE_TITLE } from '../../constants/registrationTitles'
import { Languages } from '../../interfaces/common'
import { getCurrentTitle } from '../../utils/getCurrentTitle'
import style from './LocalizedButton.module.css'
import { LanguageContext } from '../LanguageContext/LanguageContext'
import { MAIN_PAGE_TITLE } from '../../constants/profileTitle'

type LocalizationButtonProps = {
  logon?: boolean
}

export const getLogonCurrentTitle = (locale: Languages, language: string) =>
  getCurrentTitle(LOGON_PAGE_TITLE[locale], language)

export const getRegistrationCurrentTitle = (locale: Languages, language: string) =>
  getCurrentTitle(REGISTRATION_PAGE_TITLE[locale], language)

export const getProfileCurrentTitle = (locale: Languages, language: string) =>
  getCurrentTitle(MAIN_PAGE_TITLE[locale], language)

export const LocalizationButton: FC<LocalizationButtonProps> = () => {
  const { language, setLanguage } = useContext(LanguageContext)

  const uzClassName = classNames(style.localizationLang, {
    [style.disabled]: language === Languages.RU,
  })

  const ruClassName = classNames(style.localizationLang, {
    [style.disabled]: language === Languages.UZ,
  })

  const onClick = () => {
    setLanguage(language === Languages.UZ ? Languages.RU : Languages.UZ)
  }

  return (
    <button type="button" className={style.localizationButton} onClick={onClick}>
      <span className={uzClassName}>{Languages.UZ}</span>•<span className={ruClassName}>{Languages.RU}</span>
    </button>
  )
}
